<app-dashboard-container
	class="dashboard-basisvaardigheden"
	[factTable]="factTable"
	(doExport)="this.doExport(filterExpressions(), permanentFilterExpressions(), $event)"
>
	<app-filter-panel
		[defaultFilters]="actueelFilters"
		[allFilters]="allFilters()"
		(filterExpressionsChange)="filterExpressions.set($event)"
		endpoint="/basisvaardigheden"
		[permanentFilterExpressions]="permanentFilterExpressions()"
	></app-filter-panel>
	<app-filter-bar [dataRootSelection]="dataRootSelection()"></app-filter-bar>
	<section class="dashboard">
		<app-dashboard-header>
			<app-toggle-buttons [options]="dashboardAspects" [value]="aspect()" (valueChange)="qp.dispatch('aspect', $event)"> </app-toggle-buttons>
			<app-legenda
				class="cl-header-utility"
				[attribute]="['bv_fun_nr_referentieniveau_bin']"
				[exclude]="legendaExclude()"
				[keyIsClassName]="true"
			></app-legenda>
		</app-dashboard-header>
		<div>
			Bekijk de <a href="https://cumlaude.zendesk.com/hc/nl/articles/28313126475409-Basisvaardigheden">handleiding</a> voor meer uitleg over
			onze rekenwijze.
		</div>
		@switch (aspect()) {
			@case (DashboardAspect.GEMIDDELDE) {
				<app-data-tree-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions()"
					[groups]="groeperingService.huidigeGroeperingen()"
					[subgroups]="subgroups()"
					[config]="this"
				></app-data-tree-table>
			}
			@case (DashboardAspect.VERDELING) {
				<app-barchart-table
					[filters]="filterExpressions()"
					[permanentFilters]="permanentFilterExpressions()"
					[groups]="groupsVerdeling()"
					[subgroups]="subgroupsVerdeling()"
					[config]="this"
				></app-barchart-table>
			}
		}
	</section>
</app-dashboard-container>
